"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bluetoothDevice = void 0;
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
var await_timeout_1 = __importDefault(require("await-timeout"));
var ePod_1 = require("../devices/ePod");
var ConnectionState_1 = require("./ConnectionState");
var SupportedBrowsers_1 = require("../settings/SupportedBrowsers");
var BluetoothClient = /** @class */ (function () {
    function BluetoothClient(settings) {
        var _this = this;
        this._connectionState = ConnectionState_1.ConnectionState.Idle;
        this._notificationsListeners = [];
        this.setupConnectionConfig = function (config) {
            if (config === void 0) { config = {
                reconnectEnabled: true,
                connectionRetries: 3,
                connectionRetryTimeout: 5000,
                scanTimeout: 35 * 1000, // 35 seconds before timing out while scanning
            }; }
            _this._connectionConfig = config;
        };
        this.getConnectionConfig = function () { return _this._connectionConfig; };
        this.autoReconnect = function (device, server) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 1:
                        _a.sent();
                        this.connectionChanged(ConnectionState_1.ConnectionState.Connecting);
                        this._device = device;
                        this._isConnected = device.gatt.connected;
                        this._server = server;
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 2:
                        _a.sent();
                        this.connectionChanged(ConnectionState_1.ConnectionState.Connected);
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.addDisconnectionListener()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.cacheServicesAndCharacteristics()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 7:
                        _a.sent();
                        this.connectionChanged(ConnectionState_1.ConnectionState.Synchronized);
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 8:
                        _a.sent();
                        return [2 /*return*/];
                    case 9:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        this.selectDevice = function (VAPING_UUID, OptionalServices, deviceName) { return __awaiter(_this, void 0, void 0, function () {
            var filter, deviceChooser, device;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('SelectDevice() -> Asking User');
                        this.connectionChanged(ConnectionState_1.ConnectionState.Scanning);
                        if (deviceName) {
                            filter = { name: deviceName, services: [VAPING_UUID] };
                        }
                        else {
                            filter = { services: [VAPING_UUID] };
                        }
                        deviceChooser = navigator.bluetooth.requestDevice({
                            filters: [filter],
                            optionalServices: __spreadArray([], OptionalServices, true),
                        });
                        return [4 /*yield*/, await_timeout_1.default.wrap(deviceChooser, this._connectionConfig.scanTimeout, 'SCAN_TIMEOUT')];
                    case 1:
                        device = _a.sent();
                        this._device = device;
                        return [2 /*return*/, device];
                }
            });
        }); };
        this.addDisconnectionListener = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this._device.addEventListener('gattserverdisconnected', function (ev) { return __awaiter(_this, void 0, void 0, function () {
                    var didReconnect;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.connectionChanged(ConnectionState_1.ConnectionState.Disconnecting);
                                this._isConnected = false;
                                // Clear event listeners
                                this._notificationsListeners = [];
                                this.connectionChanged(ConnectionState_1.ConnectionState.Disconnected);
                                if (!(this._connectionConfig.reconnectEnabled &&
                                    navigator.userAgent.indexOf(SupportedBrowsers_1.browsers.BLUEFY) !== -1)) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.reconnect()];
                            case 1:
                                didReconnect = _a.sent();
                                if (didReconnect)
                                    return [2 /*return*/];
                                _a.label = 2;
                            case 2:
                                this.connectionChanged(ConnectionState_1.ConnectionState.Idle);
                                this._device = null;
                                this._server = null;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        this.connectGattServer = function () { return __awaiter(_this, void 0, void 0, function () {
            var server;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, await_timeout_1.default.wrap((_b = (_a = this._device) === null || _a === void 0 ? void 0 : _a.gatt) === null || _b === void 0 ? void 0 : _b.connect(), 5000, 'Connecting timed out...')];
                    case 1:
                        server = _c.sent();
                        if (!(navigator.userAgent.indexOf(SupportedBrowsers_1.browsers.BLUEFY) !== -1)) return [3 /*break*/, 3];
                        return [4 /*yield*/, server.getPrimaryServices()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        this._server = server;
                        if (!server) return [3 /*break*/, 5];
                        this._isConnected = true;
                        this.connectionChanged(ConnectionState_1.ConnectionState.Connected);
                        return [4 /*yield*/, this.addDisconnectionListener()];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.cacheServicesAndCharacteristics = function () { return __awaiter(_this, void 0, void 0, function () {
            var cacheServices, servicePromises, services;
            var _this = this;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        cacheServices = [
                            (_a = this._batSettings) === null || _a === void 0 ? void 0 : _a.VAPING,
                            (_b = this._batSettings) === null || _b === void 0 ? void 0 : _b.DEVICE_MANAGEMENT,
                            (_c = this._batSettings) === null || _c === void 0 ? void 0 : _c.LOG,
                            (_d = this._batSettings) === null || _d === void 0 ? void 0 : _d.AGE_VERIFICATION,
                        ];
                        servicePromises = cacheServices
                            .map(function (cacheService) {
                            var _a;
                            return !!(cacheService === null || cacheService === void 0 ? void 0 : cacheService.uuid) && !!((_a = _this._server) === null || _a === void 0 ? void 0 : _a.getPrimaryService)
                                ? new Promise(function (resolve) {
                                    _this._server
                                        .getPrimaryService(cacheService.uuid)
                                        .then(function (service) {
                                        Promise.allSettled(cacheService.characteristics.map(function (characteristic) {
                                            return _this._cacheCharacteristic(service, characteristic.uuid);
                                        })).then(function () { return resolve(service); });
                                    })
                                        .catch(function () { return resolve(null); });
                                })
                                : null;
                        })
                            .filter(function (cacheService) { return !!cacheService; });
                        return [4 /*yield*/, Promise.allSettled(servicePromises).then(function (results) {
                                return results
                                    .filter(function (r) { return r.status === 'fulfilled'; })
                                    .map(function (c) { return c; })
                                    .map(function (r) { return r.value; });
                            })];
                    case 1:
                        services = _e.sent();
                        return [2 /*return*/, services];
                }
            });
        }); };
        this.connect = function (deviceName) { return __awaiter(_this, void 0, void 0, function () {
            var timer, optionalServices, e_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        timer = new await_timeout_1.default();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 8, 9, 10]);
                        optionalServices = [this._batSettings.LOG.uuid, this._batSettings.DFU.uuid];
                        // Include device management service if device supports it
                        ((_a = this._batSettings) === null || _a === void 0 ? void 0 : _a.DEVICE_MANAGEMENT) &&
                            optionalServices.push(this._batSettings.DEVICE_MANAGEMENT.uuid);
                        // Include age verification service if device supports it
                        ((_b = this._batSettings) === null || _b === void 0 ? void 0 : _b.AGE_VERIFICATION) &&
                            optionalServices.push(this._batSettings.AGE_VERIFICATION.uuid);
                        // Showing and Selecting the BLE device
                        return [4 /*yield*/, this.selectDevice(this._batSettings.VAPING.uuid, optionalServices, deviceName ? deviceName : null)];
                    case 2:
                        // Showing and Selecting the BLE device
                        _c.sent();
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 3:
                        _c.sent();
                        // Set status to connecting while fetching and setting services / caching.
                        this.connectionChanged(ConnectionState_1.ConnectionState.Connecting);
                        // Attempt to connect gatt server and cache services.
                        return [4 /*yield*/, this.connectGattServer()];
                    case 4:
                        // Attempt to connect gatt server and cache services.
                        _c.sent();
                        return [4 /*yield*/, await_timeout_1.default.set(50)];
                    case 5:
                        _c.sent();
                        // eslint-disable-next-line no-unused-vars
                        return [4 /*yield*/, this.cacheServicesAndCharacteristics()];
                    case 6:
                        // eslint-disable-next-line no-unused-vars
                        _c.sent();
                        return [4 /*yield*/, this.timeHandler()];
                    case 7:
                        _c.sent();
                        this.connectionChanged(ConnectionState_1.ConnectionState.Synchronized);
                        return [2 /*return*/, {
                                isConnected: this._isConnected,
                            }];
                    case 8:
                        e_1 = _c.sent();
                        if (e_1.message === 'SCAN_TIMEOUT') {
                            this.onConnectionStateChanged(ConnectionState_1.ConnectionState.ScanTimout);
                        }
                        throw e_1;
                    case 9:
                        timer.clear();
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        this.timeHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var puffRecordCharacteristics, timeCharacteristics, vapigService, puffRecordCharacteristicsExists, timeCharacteristicsExists, valueToSet, buffer, values;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        puffRecordCharacteristics = this._batSettings.VAPING.characteristics.find(function (cacheService) { return cacheService.name === 'PUFF_RECORDS'; });
                        timeCharacteristics = this._batSettings.VAPING.characteristics.find(function (cacheService) { return cacheService.name === 'TIME'; });
                        return [4 /*yield*/, ((_a = this._server) === null || _a === void 0 ? void 0 : _a.getPrimaryService(this._batSettings.VAPING.uuid))];
                    case 1:
                        vapigService = _b.sent();
                        puffRecordCharacteristicsExists = false;
                        if (!puffRecordCharacteristics) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._characteristicExists(vapigService, puffRecordCharacteristics === null || puffRecordCharacteristics === void 0 ? void 0 : puffRecordCharacteristics.uuid)];
                    case 2:
                        puffRecordCharacteristicsExists = _b.sent();
                        _b.label = 3;
                    case 3:
                        timeCharacteristicsExists = false;
                        if (!timeCharacteristics) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._characteristicExists(vapigService, timeCharacteristics === null || timeCharacteristics === void 0 ? void 0 : timeCharacteristics.uuid)];
                    case 4:
                        timeCharacteristicsExists = _b.sent();
                        _b.label = 5;
                    case 5:
                        valueToSet = Date.now() / 1000;
                        buffer = new ArrayBuffer(4);
                        values = new DataView(buffer);
                        values.setUint32(0, valueToSet);
                        if (!(!puffRecordCharacteristicsExists && timeCharacteristicsExists)) return [3 /*break*/, 7];
                        console.log('Setting device Time to: ', new Date(valueToSet * 1000));
                        return [4 /*yield*/, this.writeCharacteristicValues(timeCharacteristics.uuid, values.buffer, false)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this.reconnect = function () { return __awaiter(_this, void 0, void 0, function () {
            var connectionAttempts, connectRetry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._device)
                            return [2 /*return*/];
                        connectionAttempts = this._connectionConfig.connectionRetries || 5;
                        connectRetry = 0;
                        _a.label = 1;
                    case 1:
                        if (!(connectRetry < connectionAttempts)) return [3 /*break*/, 7];
                        console.log('Reconnect() -> calling connect()');
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, this.connect()];
                    case 2:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        if (!this.isConnected) return [3 /*break*/, 4];
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, this.bindListeners()];
                    case 3:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        console.log('Reconnect() -> isConnected == true, stopping...');
                        // eslint-disable-next-line consistent-return
                        return [2 /*return*/, true];
                    case 4:
                        console.log('Reconnect() -> attempt timed out, retrying...');
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, await_timeout_1.default.set(this._connectionConfig.connectionRetryTimeout || 5000)];
                    case 5:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        connectRetry++;
                        return [3 /*break*/, 1];
                    case 7:
                        console.log('Reconnect() -> failed, returning...');
                        // eslint-disable-next-line consistent-return
                        return [2 /*return*/, this.isConnected];
                }
            });
        }); };
        this.bindListeners = function () { return __awaiter(_this, void 0, void 0, function () {
            var _loop_1, this_1, _i, _a, characteristicListener;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _loop_1 = function (characteristicListener) {
                            var characteristic;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, ((_b = this_1._characteristics) === null || _b === void 0 ? void 0 : _b.get(characteristicListener.uuid))];
                                    case 1:
                                        characteristic = _d.sent();
                                        // eslint-disable-next-line no-return-await
                                        // eslint-disable-next-line no-await-in-loop
                                        return [4 /*yield*/, characteristic.startNotifications().then(function () {
                                                characteristic.addEventListener('characteristicvaluechanged', characteristicListener.listener);
                                            })];
                                    case 2:
                                        // eslint-disable-next-line no-return-await
                                        // eslint-disable-next-line no-await-in-loop
                                        _d.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, _a = this._notificationsListeners;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        characteristicListener = _a[_i];
                        return [5 /*yield**/, _loop_1(characteristicListener)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.disconnect = function () {
            if (!_this._device)
                return;
            if (!_this._server)
                return;
            // Our reconnect attempt shouldn't run when you actually want to disconnect
            var reconnectEnabled = _this._connectionConfig.reconnectEnabled;
            _this._connectionConfig.reconnectEnabled = false;
            _this._server.disconnect();
            _this._isConnected = false;
            // Reset to old config
            _this._connectionConfig.reconnectEnabled = reconnectEnabled;
        };
        this.getCharacteristicValues = function (characteristicUuid) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!!this._isConnected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this._isConnected) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._readCharacteristicValues(characteristicUuid)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        return [2 /*return*/, error_2];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.writeCharacteristicValues = function (characteristicUuid, value, withResponse) { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!!this._isConnected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this._isConnected) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._writeCharacteristicValue(characteristicUuid, value, withResponse)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_3 = _a.sent();
                        return [2 /*return*/, error_3];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this._characteristicExists = function (service, bluetoothCharacteristicUUID) { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, service.getCharacteristic(bluetoothCharacteristicUUID)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this._serviceExists = function (bluetoothServiceUUID) { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ((_a = this._server) === null || _a === void 0 ? void 0 : _a.getPrimaryService(bluetoothServiceUUID))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_3 = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getServerConnection = function () {
            return _this._server;
        };
        this._batSettings = settings;
        this._isConnected = false;
        this._characteristics = new Map();
        this.connectionChanged(ConnectionState_1.ConnectionState.Idle);
        this.setupConnectionConfig();
    }
    Object.defineProperty(BluetoothClient.prototype, "notificationsListeners", {
        get: function () {
            return this._notificationsListeners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BluetoothClient.prototype, "isConnected", {
        get: function () {
            return this._isConnected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BluetoothClient.prototype, "characteristics", {
        get: function () {
            return this._characteristics;
        },
        enumerable: false,
        configurable: true
    });
    BluetoothClient.prototype.connectionChanged = function (connectionState) {
        this._connectionState = connectionState;
        if (this.onConnectionStateChanged) {
            this.onConnectionStateChanged(this._connectionState);
        }
    };
    BluetoothClient.prototype.mssSetupProgressChanged = function (mssProgressState) {
        this._mssProgressState = mssProgressState;
        if (this.onMSSProgressStateChanged) {
            this.onMSSProgressStateChanged(this._mssProgressState);
        }
    };
    BluetoothClient.prototype.payloadUploadProgressChanged = function (progressState) {
        this._payloadUploadProgressState = progressState;
        if (this.onPayloadUploadProgressStateChanged) {
            this.onPayloadUploadProgressStateChanged(this._payloadUploadProgressState);
        }
    };
    BluetoothClient.prototype.startNotifications = function (characteristicUuid, listener) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var characteristic_1, listenerIndex_1, error_4;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!!this._isConnected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, ((_a = this._characteristics) === null || _a === void 0 ? void 0 : _a.get(characteristicUuid))];
                    case 3:
                        characteristic_1 = _b.sent();
                        listenerIndex_1 = this._notificationsListeners.findIndex(function (c) { return (c === null || c === void 0 ? void 0 : c.uuid) === characteristicUuid; });
                        return [4 /*yield*/, characteristic_1.startNotifications().then(function () {
                                // Add only if not added yet
                                if (listenerIndex_1 === -1) {
                                    _this._notificationsListeners.push({
                                        uuid: characteristicUuid,
                                        listener: listener,
                                    });
                                    characteristic_1.addEventListener('characteristicvaluechanged', listener);
                                }
                            })];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5:
                        error_4 = _b.sent();
                        return [2 /*return*/, error_4];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BluetoothClient.prototype.stopNotifications = function (characteristicUuid) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var characteristic_2, error_5;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!!this._isConnected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, ((_a = this._characteristics) === null || _a === void 0 ? void 0 : _a.get(characteristicUuid))];
                    case 3:
                        characteristic_2 = _b.sent();
                        return [4 /*yield*/, characteristic_2.stopNotifications().then(function () {
                                var listenerIndex = _this._notificationsListeners.findIndex(function (c) { return (c === null || c === void 0 ? void 0 : c.uuid) === characteristicUuid; });
                                if (listenerIndex !== -1) {
                                    characteristic_2.removeEventListener('characteristicvaluechanged', _this._notificationsListeners[listenerIndex].listener);
                                    _this._notificationsListeners.splice(listenerIndex, 1);
                                }
                                return characteristic_2;
                            })];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5:
                        error_5 = _b.sent();
                        console.log(error_5);
                        return [2 /*return*/, error_5];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BluetoothClient.prototype._cacheCharacteristic = function (service, characteristicUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, service
                        .getCharacteristic(characteristicUuid)
                        .then(function (characteristic) {
                        var v = characteristic && _this._characteristics.set(characteristicUuid, characteristic);
                        return v;
                    })
                        .catch(function () {
                        return null;
                    })];
            });
        });
    };
    BluetoothClient.prototype._readCharacteristicValues = function (characteristicUuid) {
        var _a;
        var characteristic = (_a = this._characteristics) === null || _a === void 0 ? void 0 : _a.get(characteristicUuid);
        return (characteristic &&
            characteristic.readValue().then(function (value) {
                // In Chrome 50+, a DataView is returned instead of an ArrayBuffer.
                value = value.buffer ? value : new DataView(value);
                return value;
            }));
    };
    BluetoothClient.prototype._writeCharacteristicValue = function (characteristicUuid, value, withResponse) {
        var _a;
        if (withResponse === void 0) { withResponse = true; }
        var characteristic = (_a = this._characteristics) === null || _a === void 0 ? void 0 : _a.get(characteristicUuid);
        if (withResponse) {
            return (characteristic &&
                characteristic.writeValue(value).then(function () {
                    return characteristic.readValue().then(function (value) {
                        // In Chrome 50+, a DataView is returned instead of an ArrayBuffer.
                        value = value.buffer ? value : new DataView(value);
                        return value;
                    });
                }));
        }
        return characteristic && characteristic.writeValue(value);
    };
    return BluetoothClient;
}());
exports.default = BluetoothClient;
exports.bluetoothDevice = new BluetoothClient(ePod_1.ePodProfile);
